export default __webpack_public_path__ + "static/media/viewReportDownloadIcon.64e0452b.svg";